import { Button } from '@/components';
import { PageTitle } from '@/components/PageTitle';
import { useRouter } from '@tanstack/react-router';
import React from 'react';
import lostUrl from '@/assets/game/bg-loose.svg';
import { GAMES } from '@/constants/games';

const NotFoundPage: React.FC = () => {
	const router = useRouter();
	const handleRandomRedirect = () => {
		const availableGames = GAMES.filter((game) => game.isGame);
		const selected = availableGames[Math.floor(Math.random() * availableGames.length)];
		router.navigate({ to: selected?.link || '/coinflip' });
	};

	return (
		<>
			<PageTitle title="Not Found" />
			<div className="flex flex-1 justify-center align-middle flex-col">
				<div className="h-52">
					<img className="m-auto h-full" src={lostUrl} alt="Lost Suifren" loading="lazy" />
				</div>
				<h1 className="text-3xl text-center -mt-8">Page not found...</h1>
				<div className="mt-4 flex justify-center">
					<Button variant="primary" onClick={handleRandomRedirect}>
						Take me to a game
					</Button>
				</div>
			</div>
		</>
	);
};

export default NotFoundPage;
